var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99969 0C3.14002 0 0 3.11385 0 6.94089C0 10.6248 6.35094 19.2316 6.62136 19.596L6.87374 19.9366C6.90325 19.9766 6.95025 20 6.99969 20C7.0499 20 7.0966 19.9766 7.12642 19.9366L7.37864 19.596C7.64921 19.2316 14 10.6248 14 6.94089C14 3.11385 10.8595 0 6.99969 0ZM6.99969 4.45468C8.38263 4.45468 9.50717 5.56974 9.50717 6.94089C9.50717 8.31134 8.38258 9.42711 6.99969 9.42711C5.61758 9.42711 4.49222 8.31134 4.49222 6.94089C4.49222 5.56974 5.61753 4.45468 6.99969 4.45468Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLocation);
export default __webpack_public_path__ + "static/media/ic_location.32be5e083a91a16dd800232dc59edb9b.svg";
export { ForwardRef as ReactComponent };